export default {
  'subscription-funnel:page-title': 'Pets Deli voederabonnement-configurator',
  'subscription-funnel:dog': 'Mijn hond',
  'subscription-funnel:cat': 'Mijn kat',
  'subscription-funnel:WET_FOOD': 'Natvoer',
  'subscription-funnel:DRY_FOOD': 'Droogvoer',
  'subscription-funnel:BARF': 'BARF',
  'subscription-funnel:SNACKS': 'Snacks',
  'subscription-funnel:SUPPLEMENTS': 'Voedingssupplementen',
  'subscription-funnel:HEALTH': 'Gezondheid',
  'subscription-funnel:CAT_LITTER': 'Kattenbakvulling',
  'subscription-funnel:ACCESSORY': 'Accessoires',
  'subscription-funnel:button:continue': 'Verder',

  'subscription-funnel:step:preference': 'Voorkeur',
  'subscription-funnel:step:products': 'Producten',
  'subscription-funnel:step:overview': 'Overzicht',
  'subscription-funnel:step:confirm': 'Bevestiging',

  'subscription-funnel:step:payment': 'Betalen',
  'subscription-funnel:step:confirmation': 'Klaar',

  'subscription-funnel:start:header':
    'In 4 stappen naar jouw persoonlijke Pets Deli voederabonnement',
  'subscription-funnel:start:list:item-1':
    'Bespaar bij elke levering! Met een abonnement bieden we je permanent 10% korting op je favoriete producten.',
  'subscription-funnel:start:list:item-2':
    'Zonder minimale looptijd kun je je abonnement op elk moment opzeggen of pauzeren. Beloofd!',
  'subscription-funnel:start:list:item-3':
    'Volledige flexibiliteit! Kies een persoonlijk leveringsinterval en beslis wanneer je je volgende pakket wilt ontvangen.',
  'subscription-funnel:start:button-configure': '  Nu configureren',

  'subscription-funnel:preference:header': 'Kies je voorkeuren',
  'subscription-funnel:preference:sub-header':
    'Of het nu voor de hond of de kat is, alleen natvoer of een mix van BARF en droogvoer, jij hebt de keuze!',
  'subscription-funnel:preference:question-1': 'Wie wil je met je abonnement blij maken?',
  'subscription-funnel:preference:question-2': 'Welk voer moet in het abonnement zitten?',
  'subscription-funnel:preference:selection-info': 'Meerdere keuzes mogelijk',
  'subscription-funnel:preference:button:continue': 'Kies je voorkeuren',

  'subscription-funnel:products:header': ' Kies je producten',
  'subscription-funnel:products:sub-header':
    'Klik daarvoor gewoon op de producttegels. Via het info-icoon krijg je nog meer informatie.',
  'subscription-funnel:products:info-loading': 'Passende producten voor je viervoeter laden...',
  'subscription-funnel:products:modal:info-loading': 'Productinfo wordt geladen...',
  'subscription-funnel:products:results': 'Resultaten',
  'subscription-funnel:products:back-button:label': 'Terug naar de voorkeuren',

  'subscription-funnel:overview:header': 'Jouw overzicht',
  'subscription-funnel:overview:header-existing-order': 'Jouw bevestiging',

  'subscription-funnel:overview:sub-header':
    'Je bent er bijna. Controleer nog een keer of je ook geen producten bent vergeten.',

  'subscription-funnel:overview:sub-header-existing-order':
    'Je bent er bijna! Bevestig de selectie van de producten die nieuw aan je abonnement toegevoegd moeten worden.',

  'subscription-funnel:overview:new-items-existing-order': 'Nieuwe producten in je abonnement:',

  'subscription-funnel:overview:delivery-address': 'Je leveringsadres en verwachte leveringsdatum',

  'subscription-funnel:overview:delivery-date':
    'Je bestelling wordt binnenkort verwerkt en is naar verwachting klaar tegen {dateStr}',

  'subscription-funnel:overview:button:to-checkout': 'Naar de kassa',
  'subscription-funnel:overview:button:to-subscription-update': 'Bevestigen',

  'subscription-funnel:confirmation:sub-header':
    'Je kunt je abonnement op elk moment aanpassen in je account',

  'subscription-funnel:confirmation:cta': 'Nu aanpassen',

  'subscription-funnel:cart-show': 'Abonnement weergeven',
  'subscription-funnel:cart-hide': 'Abonnement verbergen',

  'subscription-funnel:existing-subscription:cart-show': 'Besteloverzicht weergeven',
  'subscription-funnel:existing-subscription:cart-hide': 'Besteloverzicht verbergen',
};
